import { Inject, Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { LoginContext } from "@app/app-modules/login/login.model";

@Injectable({
  providedIn: "root"
})
export class LoginCredentialsInterceptor implements HttpInterceptor {
  constructor(@Inject(undefined) public data: LoginContext) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedRequest: HttpRequest<any> = this.addLoginCredentialsHeader(request);
    return next.handle(modifiedRequest);
  }

  /**
   * Add login credentials header to request
   * @param request
   * @returns
   */
  addLoginCredentialsHeader(request: HttpRequest<any>) {
    const modifiedRequest: HttpRequest<any> = request.clone({
      setHeaders: {
        UserId: this.data.username,
        Pass: this.data.password
      }
    });
    return modifiedRequest;
  }
}
